<template>
  <div class="container">
    <div
      class="tab"
      :style="{
        color: tabIndex === 0 ? '#fff' : '#222',
        'background-color': tabIndex === 0 ? 'rgba(0,0,0,0)' : '#fff',
      }"
      v-show="$route.meta.tabMenu == undefined || $route.meta.tabMenu"
    >
      <i
        @click="jumpSearch"
        :class="['searchBtn', tabIndex === 0 ? 'active' : '']"
      ></i>
      <div @click="checkTab(0)">
        <li :class="{ active: tabIndex === 0 }">推荐</li>
        <span :class="{ line: tabIndex === 0 }"></span>
      </div>
      <div @click="checkTab(1)">
        <li :class="{ active: tabIndex === 1 }">订阅</li>
        <span :class="{ line: tabIndex === 1 }"></span>
      </div>
      <div @click="checkTab(2)">
        <li :class="{ active: tabIndex === 2 }">全部</li>
        <span :class="{ line: tabIndex === 2 }"></span>
      </div>
    </div>
    <!-- 路由出口 -->
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
import Contents from "@/request/base.default.js";
import { getCookie, checkWx, navigate } from "@/pages/index/custom";

export default {
  data() {
    return {
      tabIndex: 0,
      sessionid: "",
    };
  },
  methods: {
    // 选项卡切换
    checkTab(index) {
      this.tabIndex = index;
      const vars = window.location.hash
        .substring(window.location.hash.indexOf("?") + 1)
        .split("&");
      let params = {};
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        params[pair[0]] = pair[1];
      }
      if (index === 0) {
        this.$router.replace({ path: "/patting/comment", query: params });
      } else if (index === 1) {
        this.$router.replace({ path: "/patting/order", query: params });
      } else if (index === 2) {
        this.$router.replace({ path: "/patting/all", query: params });
      }
    },
    jumpSearch() {
      navigate("", Contents.mainURL + "/app/index/search");
      // window.location.href
    },
  },
  created() {
    this.sessionid = getCookie(Contents.cookie_key);
    let currentRoute = this.$route.path.substring(
      this.$route.path.lastIndexOf("/") + 1
    );
    if (currentRoute === "comment") {
      this.tabIndex = 0;
    } else if (currentRoute === "order") {
      this.tabIndex = 1;
    } else {
      this.tabIndex = 2;
    }
  },
  watch: {
    $route() {
      let currentRoute = this.$route.path.substring(
        this.$route.path.lastIndexOf("/") + 1
      );
      if (currentRoute === "comment") {
        this.tabIndex = 0;
      } else if (currentRoute === "order") {
        this.tabIndex = 1;
      } else {
        this.tabIndex = 2;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
.searchBtn {
  position: absolute;
  left: 1.25rem;
  top: 50%;
  width: 1.5rem;
  height: 1.5rem;
  margin-top: -12px;
  background: url(../../../../assets/img/icon_search.png) no-repeat;
  background-size: 100% 100%;
  &.active {
    background: url(../../../../assets/img/icon_search2.png) no-repeat;
    background-size: 100% 100%;
  }
}
.tab {
  height: 3.75rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
}
.tab > div {
  position: relative;
}
.tab li {
  margin-right: 1.5rem;
  font-size: 16px;
  font-weight: 400;
  height: 100%;
  line-height: 3.75rem;
  transition: all 0.3s;
  list-style: none;
}
.tab li.active {
  font-size: 24px;
  font-weight: 600;
}
.tab .line {
  position: absolute;
  bottom: 8px;
  left: 50%;
  margin-left: -20px;
  width: 1.25rem;
  height: 0.25rem;
  background-color: #ff4c67;
  box-shadow: 0px 2px 6px 0px #fd7c90;
  border-radius: 10px;
}
</style>